<template>
  <div class="statistic-page">
    <div class="statistic-hero">
      <div>
        <p class="hero-kicker mb-1">داشبورد آمار</p>
        <h1 class="mb-2">آمار فروش و عملکرد فروشگاه</h1>
        <p class="mb-0 hero-desc">
          خلاصه فروش، روند روزانه و ماهانه، و پرفروش‌ترین محصولات در یک نگاه.
        </p>
      </div>
      <div class="hero-badge">
        <i class="bi bi-bar-chart-line"></i>
      </div>
    </div>

    <sales-overview/>

    <div class="section-title">
      <h3 class="mb-1">آمار محصولات</h3>
      <p class="text-muted mb-0">پرفروش‌ترین‌ها، بزرگ‌ترین سفارش و پربازدیدترین محصولات</p>
    </div>

    <div class="row">
      <div class="mt-3 col-lg-6">
        <statistic-top-sell-product class="h-100 product-stat-card"/>
      </div>
      <div class="mt-3 col-lg-6">
        <statistic-top-sell-product-of-month class="h-100 product-stat-card"/>
      </div>
      <div class="mt-3 col-lg-6">
        <static-biggest-sell class="h-100 product-stat-card"/>
      </div>
      <div class="mt-3 col-lg-6">
        <statistic-most-viewed-product class="h-100 product-stat-card"/>
      </div>
    </div>
  </div>
</template>

<script>
import "../components/dashboard/Statistic/statistic-ui.css";
import StatisticTopSellProduct from "../components/dashboard/Statistic/StatisticTopSellProduct.vue";
import StatisticTopSellProductOfMonth from "../components/dashboard/Statistic/StatisticTopSellProductOfMonth.vue";
import StaticBiggestSell from "../components/dashboard/Statistic/StaticBiggestSell.vue";
import StatisticMostViewedProduct from '../components/dashboard/Statistic/StatisticMostViewedProduct.vue'
import SalesOverview from '../components/dashboard/Statistic/SalesOverview.vue'

export default {
  name: "Statistic",
  components: {
    SalesOverview,
    StatisticMostViewedProduct,
    StaticBiggestSell,
    StatisticTopSellProductOfMonth,
    StatisticTopSellProduct,
  },
}
</script>

<style scoped>
.statistic-page {
  padding: 8px 4px 24px;
}

.statistic-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: linear-gradient(135deg, #1e1e1e 0%, #3a3a3a 55%, #eb3d60 140%);
  color: #fff;
  border-radius: 22px;
  padding: 24px 28px;
  margin-bottom: 22px;
}

.hero-kicker {
  opacity: 0.8;
  font-size: 13px;
}

.statistic-hero h1 {
  font-size: 28px;
  font-weight: 800;
}

.hero-desc {
  opacity: 0.86;
}

.hero-badge {
  width: 64px;
  height: 64px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  flex-shrink: 0;
}

.section-title {
  margin: 12px 0 4px;
}

.section-title h3 {
  font-weight: 800;
}

.product-stat-card {
  border-radius: 18px;
}

@media (max-width: 767px) {
  .statistic-hero {
    padding: 18px;
  }

  .statistic-hero h1 {
    font-size: 22px;
  }
}
</style>
